import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AppVersion from "@/components/AppVersion.vue";
import { theme } from "@entersekt/types/build/3-5-0/endpoint";
import { getStoredTheme, getCachedImages } from "@/store/index";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "ed06f0c8": (_unref(backgroundColor)),
  "ec5ffcd8": (_unref(backgroundImage))
}))

let backgroundColor = ref("#ffffff");
let backgroundImage = ref("");
function setBackgroundColor(background: string) {
  backgroundColor.value = background;
}

function setBackgroundImage(background: string) {
  backgroundImage.value = `url(${background})`;
}

const cachedTheme = ref<theme>({});
const storedTheme = getStoredTheme();
if (storedTheme) {
  cachedTheme.value = storedTheme;
}

const storedImages = getCachedImages();
if (storedImages) {
  var images = [];
  for (let i = 0; i < storedImages.length; i++) {
    images[i] = new Image();
    images[i].src = storedImages[i];
  }
}

if (cachedTheme.value.pageBackgroundColor) {
  setBackgroundColor(cachedTheme.value.pageBackgroundColor);
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, {
      class: "view",
      cachedTheme: cachedTheme.value,
      onSetBackgroundColor: setBackgroundColor,
      onSetBackgroundImage: setBackgroundImage
    }, null, 8, ["cachedTheme"]),
    _createVNode(AppVersion)
  ], 64))
}
}

})